<script lang="ts" setup>
import type { StrapiBuilderPageData } from '@autobid/strapi-integration/typescript/strapi/Page'
import { STRAPI_SEO_INJECTION_KEY } from '@autobid/ui/constants/STRAP_SEO_INJECTION_KEY'

interface Props {
  pageData?: StrapiBuilderPageData | null
}

const props = defineProps<Props>()

provide(STRAPI_SEO_INJECTION_KEY, props.pageData?.page.seo)
</script>

<template>
  <template v-if="pageData">
    <SeoTags
      :seo-data="pageData.page.seo"
      :localizations="pageData.page.localizations"
    />

    <CommonStrapiPageAdminNav :page="pageData.page" />

    <ClientOnly>
      <teleport to="#teleport-language-switcher">
        <LayoutLanguageSwitcher
          x="right"
          y="bottom"
          :locales="pageData.page.localizations"
        />
      </teleport>

      <teleport to="#teleport-language-switcher-mobile">
        <LayoutLanguageSwitcher
          x="left"
          y="top"
          :locales="pageData.page.localizations"
        />
      </teleport>
    </ClientOnly>

    <div class="w-full">
      <AutobidRenderComponents :components="pageData.headerSections" />

      <common-sidebared-page
        v-if="pageData.sidebarSections.length"
        :width="pageData.page.sidebarWidth"
      >
        <template #page>
          <AutobidRenderComponents :components="pageData.components" />
          <slot />
        </template>

        <template #sidebar>
          <AutobidRenderComponents
            :components="pageData.sidebarSections"
            :as-sidebar="true"
          />
        </template>
      </common-sidebared-page>
      <template v-else>
        <slot />
        <AutobidRenderComponents :components="pageData.components" />
      </template>
    </div>
  </template>
</template>
